
import React from "react";
import { Loader2 } from "lucide-react";
import MobileNotificationCard from "./MobileNotificationCard";
import { SupabaseNotification } from "@/types/notifications";
import { getStatusDisplayName } from "@/utils/statusMappings";

interface MobileNotificationCardListProps {
  notifications: SupabaseNotification[];
  isLoading: boolean;
  formatDate: (date: string) => string;
  handleNotificationClick: (id: string) => void;
  handleArchive: (e: React.MouseEvent, id: string) => void;
  handleRestore: (e: React.MouseEvent, id: string) => void;
  handleDelete: (e: React.MouseEvent, id: string) => void;
  viewMode: "active" | "archived";
  selectedStatuses: string[];
  getUnreadChatCount?: (notificationId: string) => number;
}

const MobileNotificationCardList = ({
  notifications,
  isLoading,
  formatDate,
  handleNotificationClick,
  handleArchive,
  handleRestore,
  handleDelete,
  viewMode,
  selectedStatuses,
  getUnreadChatCount
}: MobileNotificationCardListProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-40">
        <Loader2 className="h-6 w-6 animate-spin mr-2" />
        <span>Meldingen laden...</span>
      </div>
    );
  }
  
  if (notifications.length === 0) {
    if (viewMode === "active" || viewMode === "archived") {
      return (
        <div className="text-center py-10">
          {viewMode === "active" 
            ? "Geen actieve meldingen gevonden" 
            : "Geen gearchiveerde meldingen gevonden"}
        </div>
      );
    } else {
      return (
        <div className="text-center py-10">
          Geen meldingen gevonden met de geselecteerde filters
        </div>
      );
    }
  }
  
  return (
    <div className="space-y-3">
      {notifications.map((notification) => (
        <MobileNotificationCard
          key={notification.id}
          notification={notification}
          formatDate={formatDate}
          onNotificationClick={handleNotificationClick}
          onArchive={handleArchive}
          onRestore={handleRestore}
          onDelete={handleDelete}
          viewMode={viewMode}
          selectedStatuses={selectedStatuses}
          unreadChatCount={getUnreadChatCount?.(notification.id) ?? 0}
        />
      ))}
      
      {selectedStatuses.length > 0 && (
        <div className="text-sm text-muted-foreground italic text-center">
          {selectedStatuses.length === 1 
            ? `Filtering op status: ${getStatusDisplayName(selectedStatuses[0])}`
            : `Filtering op ${selectedStatuses.length} statussen`
          }
        </div>
      )}
    </div>
  );
};

export default MobileNotificationCardList;
